<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} chính sách thiết bị</h1>

          <div style="float: right">
            <button type="button" @click="$router.push('/policy-device')" class="btn btn-light">
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <div class="form">
                <ValidationProvider rules="required" vid="name" name="Tên chính sách">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"
                      >Tên chính sách<span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model.trim="dataRequest.name" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="typeAppendix"
                  name="Loại phụ lục"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Loại phụ lục<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2 v-model="dataRequest.typeAppendix" :options="Config.typeAppendix" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="duration"
                  name="Thời hạn"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Thời hạn (Tháng)<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" v-model="dataRequest.duration" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="typeDevice"
                  name="Loại chính sách thuê"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Loại chính sách thuê<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2 v-model="dataRequest.type" :options="Config.optionType" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  vid="idAbbreviation"
                  name="Loại thiết bị"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">
                      Loại thiết bị<span style="color: red"> *</span>
                    </label>
                    <div class="col-sm-9">
                      <Select2 v-model="dataRequest.categoryId" :options="dataDevice" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="numberCheck"
                  vid="description"
                  name="Doanh số tích lũy"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Doanh số tích lũy</label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" v-model="dataRequest.totalSales" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider
                  rules="numberCheck"
                  vid="description"
                  name="Doanh số tối thiểu để được tính tổng"
                  v-if="$route.name === 'createPolicyDevice'"
                >
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"
                      >Doanh số tối thiểu để được tính tổng</label
                    >
                    <div class="col-sm-9">
                      <input
                        type="number"
                        class="form-control"
                        v-model="dataRequest.minimumSales"
                      />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div class="mb-90">
                <ValidationProvider rules="required" vid="priority" name="Ưu tiên">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"
                      >Ưu tiên <span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="dataRequest.priority" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-6" v-if="$route.name === 'createPolicyDevice'">
              <div class="form" v-for="(item, index) in dataRequest.priceList" :key="index">
                <ValidationProvider rules="required" vid="name" name="Tên mức">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label"
                      >Tên mức <span style="color: red"> *</span></label
                    >
                    <div class="col-sm-9">
                      <input type="text" class="form-control" v-model="item.name" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="numberCheck" vid="description" name="Doanh số tối thiểu">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Doanh số tối thiểu</label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" v-model="item.from" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="numberCheck" vid="description" name="Doanh số tối đa">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Doanh số tối đa</label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" v-model="item.to" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
                <ValidationProvider rules="numberCheck" vid="price" name="Tiền thuê">
                  <div class="form-group row" slot-scope="{ errors }">
                    <label class="col-sm-3 col-form-label">Tiền thuê</label>
                    <div class="col-sm-9">
                      <input type="number" class="form-control" v-model="item.price" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </div>
                  </div>
                </ValidationProvider>
              </div>
              <div @click="addList" class="btn btn-success btn-primary ml-2">Thêm mức</div>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  export default {
    name: 'request-policy-device',
    data() {
      return {
        Config,
        dataRequest: {
          priceList: [
            {
              name: '',
              from: null,
              to: null,
              price: '',
            },
          ],
        },
        dataDevice: [],
        showLoading: false,
      }
    },
    created() {
      if (this.$route.params.id) {
        this.fetchData()
      } else {
        DeviceService.typeDeviceConfig()
          .then(
            s => s.data?.map(s => ({ id: s.id, text: s.name, abbreviation: s.abbreviation })) ?? []
          )
          .then(
            s =>
              (this.dataDevice = [
                { id: 'OTHER', text: 'Thiết bị khác', abbreviation: 'OTHER' },
                ...s,
              ])
          )
      }
    },
    methods: {
      async submitRequest() {
        try {
          const params = this.preareData()
          this.showLoading = true
          if (this.dataRequest.id) {
            const response = await DeviceService.updatePolicyDevice(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật chính sách bảo hành thành công').then(() =>
                this.$router.push('/policy-device')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await DeviceService.createPolicyDevice(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới chính sách bảo hành thành công').then(() =>
                this.$router.push('/policy-device')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      preareData() {
        const data = cloneDeep(this.dataRequest)
        if (this.$route.name === 'createPolicyDevice') {
          const dataFindDevice = this.dataDevice.find(item => item.id === data.categoryId)
          data.categoryCode = dataFindDevice.abbreviation
        }
        if (data.totalSales) data.totalSales = Number(data.totalSales)
        if (data.minimumSales) data.minimumSales = Number(data.minimumSales)
        return data
      },
      async fetchData() {
        const ids = [this.$route.params.id]
        if (ids) {
          try {
            this.showLoading = true
            const responsive = await DeviceService.getDetailPolicyDevice({ ids })
            if (responsive.code === 1000 && responsive.data.length > 0) {
              this.dataRequest = responsive.data[0]
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
      addList() {
        this.dataRequest.priceList.push({
          name: '',
          from: null,
          to: null,
          price: '',
        })
      },
    },
  }
</script>

<style scoped>
  .form {
    border-bottom: 1px solid #bbbbbb;
    margin-bottom: 1rem;
  }
</style>
